export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrato:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["totale"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per pagina"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostra"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risultati"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["di"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scambio"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scambi"])}
}